import sampleCreation5 from './sample-creation-5.json'
import { GridItemData } from './StudioTypes'

export interface CreationData {
    id: number
    items: GridItemData[]
}

export const sampleCreations: any = {
    creation_4: sampleCreation5,
}
